<template>
  <!-- HEADER -->
  <div class="d-flex align-center ga-4 mb-8">
    <h1 class="font-weight-bold">Lineas</h1>
    <v-divider class="mx-4" inset vertical></v-divider>
    <v-btn
      color="red-darken-4"
      rounded="pill"
      @click="dialogframecreate = true"
    >
      + Crear
    </v-btn>
    <v-divider class="mx-4" inset vertical></v-divider>
    <v-btn color="teal-darken-1" @click="getArbolDecision()" rounded="pill">
      Generar Dialogo
    </v-btn>
    <v-divider class="mx-4" inset vertical></v-divider>
    <v-btn color="teal-darken-1" @click="getLMemoria()" rounded="pill">
      Generar Parametros
    </v-btn>

    <v-divider class="mx-4" inset vertical></v-divider>
    <!-- Filtros -->
    <v-dialog v-model="dialogframe" persistent max-width="1000px">
      <template v-slot:activator="{ props }">
        <v-btn
          color="cyan"
          icon="mdi-filter-menu"
          dark
          class="mb-2"
          v-bind="props"
        >
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="red-darken-4">
          <v-toolbar-title
            ><v-icon left>mdi-filter-menu</v-icon> Filtros
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="d-none d-md-block" dark text @click="reset"
              >Limpiar</v-btn
            >
            <v-btn class="d-none d-md-block" dark text @click="ValidateCampos"
              >Consultar</v-btn
            >
            <v-btn
              class="d-none d-md-block"
              dark
              text
              @click="dialogframe = false"
              >Cerrar</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" autocomplete="off">
            <v-row v-for="(datos, i) in modelfiltro" :key="i">
              <!-- Filtro -->
              <v-col cols="6">
                <v-autocomplete
                  v-model="datos.filtro"
                  :items="items"
                  item-title="descripcion"
                  item-value="filtro"
                  label="Tipo de filtro:"
                  :clearable="datos.clear"
                  :readonly="datos.lectura"
                ></v-autocomplete>
              </v-col>
              <!-- Contenido -->
              <v-col cols="6">
                <v-text-field
                  v-model="datos.contenido"
                  :label="datos.label"
                  :clearable="datos.clear"
                  :readonly="datos.lectura"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

  <!-- CARD -->
  <v-card
    v-for="line in lines"
    :key="line.LineaCredito"
    class="pa-6 mb-6 line-card"
    rounded="xl"
    elevation="2"
  >
    <!-- TOP -->
    <div class="d-flex justify-space-between align-center">
      <h3 class="font-weight-bold">
        {{ line.Descripcion }}
      </h3>

      <span class="text-medium-emphasis">
        Solicitud actual: {{ line.NumeroConsecutivo }}
      </span>

      <v-btn
        icon="mdi-pencil"
        @click="editItem(line, 0)"
        variant="text"
      ></v-btn>
    </div>

    <!-- BUTTONS -->
    <div class="d-flex justify-end ga-3 mt-6">
      <!-- Relación Procesos Datos -->
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon @click="editItem(line, 4)" color="orange" v-bind="props"
            >mdi-multicast</v-icon
          >
        </template>
        <span>Relación Linea Proceso</span>
      </v-tooltip>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon @click="editItem(line, 1)" color="red-darken-4" v-bind="props"
            >mdi-arrow-decision-outline</v-icon
          >
        </template>
        <span>Procesos</span>
      </v-tooltip>
      <v-divider class="mx-4" inset vertical></v-divider>
      <!-- Datos -->
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon
            @click="editItem(line, 2)"
            color="blue-darken-4"
            v-bind="props"
            >mdi-database-plus-outline</v-icon
          >
        </template>
        <span>Datos</span>
      </v-tooltip>
      <v-divider class="mx-4" inset vertical></v-divider>
      <!-- Valores Numérico -->
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon @click="editItem(line, 5)" color="blue" v-bind="props"
            >mdi-numeric</v-icon
          >
        </template>
        <span>Valores Numéricos</span>
      </v-tooltip>
      <v-divider class="mx-4" inset vertical></v-divider>
      <!-- Valores Alfanumérico -->
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon @click="editItem(line, 6)" color="orange" v-bind="props"
            >mdi-alphabetical-variant</v-icon
          >
        </template>
        <span>Valores Alfanuméricos</span>
      </v-tooltip>
      <v-divider class="mx-4" inset vertical></v-divider>
      <!-- Consultar Dialogo -->
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon
            @click="editItem(line, 3)"
            color="green-darken-4"
            v-bind="props"
            >mdi-chat-processing</v-icon
          >
        </template>
        <span>Consultar Dialogo</span>
      </v-tooltip>
    </div>
  </v-card>

  <!-- Campos Registro -->
  <v-dialog v-model="dialogframecreate" persistent max-width="1500px">
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>{{ iconTitle }}</v-icon> {{ formTitle }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="
              dialogframecreate = false;
              editedItem = null;
              editedIndex = -1;
            "
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <proceso-registro
          v-if="dialogframecreate"
          :infoedit="editedItem"
          v-bind:page="dialogframecreate"
          v-on:update:page="dialogframecreate = $event"
          v-bind:Exito="respuestapostput"
          v-on:update:Exito="respuestapostput = $event"
          v-bind:componenteview="componenteview"
          v-on:update:componenteview="componenteview = $event"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          v-bind:titledialogbtn="titledialogbtn"
          v-on:update:titledialogbtn="titledialogbtn = $event"
          v-bind:iconodialogbtn="iconodialogbtn"
          v-on:update:iconodialogbtn="iconodialogbtn = $event"
          v-bind:llavesiframe="llaves"
          v-on:update:llavesiframe="llaves = $event"
          :infopermisos="param1"
          :editedIndex="editedIndex"
        ></proceso-registro>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Progreso -->
  <v-dialog v-model="progreso" persistent width="auto">
    <v-card color="red-darken-4">
      <v-card-text>
        Espera un momento...
        <v-toolbar align="center" color="red-darken-4">
          <v-img
            class="mx-auto"
            :width="5"
            src="/static/iconos/logo2.png"
          ></v-img>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Registro from "@/views/TCI/ProcesosP/Lineas/LineasRegistro.vue";
import {
  getLineas,
  getArbolDecision,
  getLMemoria,
} from "@/views/TCI/ProcesosP/Lineas/LineasService";
export default {
  name: "app-lineas",
  props: {
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    infopermisos: {
      type: String,
      default: "",
      Description: "Información de permisos",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    paramiframeuno: {
      type: String,
      default: "0",
      Description: "Parametro enviado de la pantalla principal",
    },
  },
  components: {
    "proceso-registro": Registro,
  },
  data() {
    return {
      itemsPerPage: 1,
      selected: [],
      search: "",
      editedItem: null,
      editedIndex: -1,
      respuestapostput: "",
      consult: false,
      progreso: false,
      dialogframe: false,
      dialogframecreate: false,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      lines: [],
      menubuttoms: [],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "Descripcion",
          filtro: null,
          contenido: null,
          lectura: true,
          clear: false,
          label: "Descripción:",
        },
        {
          campo: "Consecutivo",
          filtro: null,
          contenido: null,
          lectura: true,
          clear: false,
          label: "Consecutivo:",
        },
      ],
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      param1: [],
      busquedacompleta: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear Registro"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "Actualizar registro"
        : "Consultar registro";
    },
    iconTitle() {
      return this.editedIndex === -1
        ? "mdi-plus"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "mdi-pencil"
        : "mdi-eye";
    },
  },
  watch: {
    dialogframecreate(val) {
      if (!val && this.respuestapostput == "Exito" && this.consult) {
        this.respuestapostput = null;
        this.ValidateCampos();
        this.itemsPerPage = 1;
      }
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.busquedacompleta = false;
      this.consult = validate;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.consult = true;
        this.getConsultData();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },

    // Consulta Tablero
    async getConsultData() {
      this.lines = [];
      this.selected = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        parametro2: this.paramiframeuno,
        busquedacompleta: this.busquedacompleta,
      };
      try {
        const result = await getLineas(data);
        this.lines = result;
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
        this.dialogframe = false;
      }
    },

    // Item editar
    editItem(item, iconoelegido) {
      this.componenteview = iconoelegido;
      this.infoitem = item;
      switch (iconoelegido) {
        case 0:
          this.editedIndex = this.lines.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.dialogframecreate = true;
          break;
        case 1: // Procesos
          this.$router.push({
            name: "Procesos",
            params: { linea: item.LineaCredito, descLinea: item.Descripcion },
            query: { linea: item.LineaCredito, descLinea: item.Descripcion },
          });
          break;
        case 2: // Datos
          this.$router.push({
            name: "Datos",
            params: { linea: item.LineaCredito, descLinea: item.Descripcion },
            query: { linea: item.LineaCredito, descLinea: item.Descripcion },
          });
          break;
        case 3: // Consulta Dialogo
          this.iconodialogbtn = "mdi-home-group";
          this.titledialogbtn = "Consulta Dialogo";
          this.dialogframeboton = true;
          break;
        case 4: // Relacion Linea Proceso
          this.$router.push({
            name: "RelacionLineaCreditoProceso",
            params: { linea: item.LineaCredito, descLinea: item.Descripcion },
            query: { linea: item.LineaCredito, descLinea: item.Descripcion },
          });
          break;
        case 5: // Valoracion Numérica
          this.$router.push({
            name: "ValoracionNumerica",
            params: { linea: this.linea, descLinea: this.descLinea },
            query: { linea: this.linea, descLinea: this.descLinea },
          });
          break;
        case 6: // Valoracion Alfanumérica
          this.$router.push({
            name: "ValoracionAlfaNumerica",
            params: { linea: this.linea, descLinea: this.descLinea },
            query: { linea: this.linea, descLinea: this.descLinea },
          });
          break;
      }
    },

    // Confirmación de eliminación
    Eliminar() {
      if (this.selected.length != 0 && this.selected != null) {
        this.$swal({
          icon: "question",
          title: "Eliminar Información",
          html: "¿Está seguro que desea eliminar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.getDelete();
          }
        });
      } else {
        this.$swal({
          icon: "info",
          title: "Seleccione la fila a eliminar",
          html: "Lo sentimos, debe seleccionar la celda o celdas para eliminar el registro.",
        });
      }
    },

    // Consulta las eliminaciones
    async getDelete() {
      this.axios
        .delete("/ActivosO/Seguros/", { data: this.selected })
        .then((response) => {
          if (response.data === "Exito") {
            this.$swal({
              icon: "success",
              title: "Información Eliminada",
              html: "La información se ha eliminado correctamente.",
            });
            this.getConsultData();
            this.selected = [];
          } else {
            this.$swal({
              icon: "error",
              title: "Error al guardar los datos",
              html: response.data.toString(),
            });
          }
        })
        .catch((e) =>
          this.$swal({
            icon: "error",
            title:
              "No se logro la eliminación debido a que tiene datos relacionados",
            html:
              "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso:<br><small><code>" +
              e.toString() +
              "</code></small>",
          }),
        );
    },

    // Consultamos Arbol Decision
    async getArbolDecision() {
      this.progreso = true;
      try {
        const result = await getArbolDecision();
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consultamos Datos en Memoria
    async getLMemoria() {
      this.progreso = true;
      try {
        const result = await getLMemoria();
        this.$swal({
          icon: "success",
          title: "¡Éxito!",
          html: " El registro fue guardado correctamente.",
        });
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
    },

    // Cerrar combos
    CerrarCombos() {
      this.dialogframeboton = false;
    },

    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1;
        this.ValidateCampos();
      }
    },

    // Parametros Iframe
    parametrosiframe() {
      var splitparam1 = this.infopermisos.split("");
      this.param1 = splitparam1;
      this.ValidateCampos();
    },
  },
  mounted() {
    if (!this.pageiframe) {
      this.parametrospaginas();
    } else {
      this.parametrosiframe();
    }
  },
};
</script>
